import { render, staticRenderFns } from "./PrivateMigrate.vue?vue&type=template&id=420548aa&scoped=true"
import script from "./PrivateMigrate.vue?vue&type=script&lang=js"
export * from "./PrivateMigrate.vue?vue&type=script&lang=js"
import style0 from "./PrivateMigrate.vue?vue&type=style&index=0&id=420548aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420548aa",
  null
  
)

export default component.exports